<template>
    <div>

        <div v-if="loadingFrequencia" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>

            <table class="table table-striped table-frequencia">
                <thead>
                    <tr>
                        <th class="u-text-center"></th>
                        <th 
                            :colspan="item" 
                            class="u-text-center"
                            v-for="(item, i) in frequencia['qtd_max_horario']"
                            :key="i"
                        >
                            {{ $CONSTANTS.NOME_MES(i) }}
                        </th>
                    </tr>
                </thead>
                <thead>                    
                    <tr>
                        <td class="u-text-center">DIA</td>
                        <template v-for="item in frequencia['qtd_max_horario']">
                            <td 
                                class="u-text-center"
                                v-for="(qtd, j) in item"
                                :key="j"
                            >
                                {{ item > 1 ? (j+1)+'º' : 'Frequência' }}
                            </td>
                        </template>
                    </tr>
                </thead>
                <tbody>


                    <tr v-for="(dia, id) in frequencia['chamada']" :key="id">

                        <td class="u-text-center">{{ id }}</td>

                        <template v-for="(mes, ii) in dia">

                            <template v-if="mes.length > 0">
                                <td v-for="(horario, ih) in mes" :key="(id+'1'+ih)" class="u-text-center">
                                    {{ horario['v'] }}
                                </td>
                                <td title="Dia não computado" v-for="(qtd, ic) in (frequencia['qtd_max_horario'][ii] - mes.length)" :key="(id+'2'+ic)" class="u-text-center">
                                    -
                                </td>
                            </template>
                            <template v-else>

                                <td v-for="(qtd, ie) in frequencia['qtd_max_horario'][ii]" :key="(id+'3'+ie)" class="u-text-center">
                                    -
                                </td>

                            </template>


                        </template>

                    </tr>


                    
                </tbody>
            </table>
            


        </div>
        
    </div>
</template>
<script>


export default {
    props: ['id'],
    data: () => ({
        frequencia: {},
        loadingFrequencia: true
    }),
    mounted () {

        this.getFrequencia();

    },
    methods: {
        getFrequencia(){
            
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia/getFrequenciaById/${this.id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.frequencia = response.data;
                this.loadingFrequencia = false;  

                console.log(this.frequencia);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },        
    },
    components:{  }
}
</script>
<style>
    .table-frequencia td, .table-frequencia th {
        border: 1px solid #ccc !important;
    }
</style>
